export { default } from './CognitiveJourney';
